import React, { useState } from 'react';
import './Workshops.css';

const Workshops = () => {
  const [selectedWorkshop, setSelectedWorkshop] = useState(null);
  const [showBookingModal, setShowBookingModal] = useState(false);
  const [bookingData, setBookingData] = useState({
    name: '',
    email: '',
    phone: '',
    participants: '1'
  });

  const workshopData = {
    id: 1,
    title: "HECATE PERFUME",
    subtitle: "EXTRAORDINARY SCENTS",
    workshopType: "PARFÜM TASARIM WORKSHOP",
    description: "Ham esanslardan kişisel parfüm ritüelinize. Seçtiğiniz her damla benzersiz hikayenizin bir parçası haline gelir ve sadece size ait bir kokuya karışır. Saf notaları özünüzü yakalayan bir parfüme dönüştürmenin büyüsünü yaşayın.",
    date: "21 OCAK 2026",
    time: "18:00 - 21:00",
    location: "WITHCO COWORKING SPACE BAYRAKLI",
    duration: "3 saat",
    price: 2500,
    icon: "♾️"
  };

  const createWhatsAppMessage = (formData) => {
    const phoneNumber = '905411969043';
    const totalPrice = workshopData.price * parseInt(formData.participants);
    
    const message = `HECATE PERFUME ATÖLYESİ - KAYIT

Katılımcı Bilgileri:
• Ad Soyad: ${formData.name}
• E-posta: ${formData.email}
• Telefon: ${formData.phone}
• Katılımcı Sayısı: ${formData.participants}

Atölye Detayları:
• Atölye: ${workshopData.title} - ${workshopData.subtitle}
• Tarih: ${workshopData.date} | ${workshopData.time}
• Lokasyon: ${workshopData.location}
• Toplam Tutar: ${totalPrice} TL`;

    return `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
  };

  const handleBookingSubmit = (e) => {
    e.preventDefault();
    if (!bookingData.name || !bookingData.email || !bookingData.phone) {
      return;
    }

    const whatsappUrl = createWhatsAppMessage(bookingData);
    window.open(whatsappUrl, '_blank');
    setBookingData({ name: '', email: '', phone: '', participants: '1' });
    setShowBookingModal(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setBookingData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <div className="ws-luxury-container">
      {/* Hero Section - Minimal Lüks */}
      <section className="ws-luxury-hero">
        <div className="ws-hero-gradient-overlay"></div>
        <div className="ws-luxury-hero-content">
          <div className="ws-date-elegant">
            <span className="ws-date-day">21</span>
            <div className="ws-date-month-year">
              <span className="ws-date-month">OCAK</span>
              <span className="ws-date-year">2026</span>
            </div>
          </div>
          
          <div className="ws-title-elegant">
            <h1 className="ws-main-title">HECATE</h1>
            <h2 className="ws-sub-title">PERFUME</h2>
            <div className="ws-title-divider"></div>
            <p className="ws-hero-tagline">EXTRAORDINARY SCENTS</p>
          </div>

          <div className="ws-workshop-type-elegant">
            PARFÜM TASARIM WORKSHOP
          </div>

          <p className="ws-description-elegant">
            Ham esanslardan kişisel parfüm ritüelinize. Seçtiğiniz her damla benzersiz hikayenizin bir parçası haline gelir.
          </p>

          <div className="ws-hero-cta">
            <button 
              className="ws-cta-button"
              onClick={() => setShowBookingModal(true)}
            >
              <span className="ws-cta-text">REZERVASYON</span>
              <span className="ws-cta-arrow">→</span>
            </button>
          </div>
        </div>
      </section>

      {/* Workshop Details - Elegant Card */}
      <section className="ws-workshop-elegant">
        <div className="ws-container-elegant">
          <div className="ws-workshop-card-elegant">
            <div className="ws-card-header-elegant">
              <div className="ws-header-icon">♾️</div>
              <div className="ws-header-content">
                <h3>{workshopData.title}</h3>
                <p className="ws-header-subtitle">{workshopData.subtitle}</p>
              </div>
              <div className="ws-header-date">
                {workshopData.date}
              </div>
            </div>

            <div className="ws-card-body-elegant">
              <p className="ws-full-description">
                {workshopData.description}
              </p>

              <div className="ws-details-grid-elegant">
                <div className="ws-detail-item-elegant">
                  <div className="ws-detail-icon">🕒</div>
                  <div>
                    <div className="ws-detail-label">SAAT</div>
                    <div className="ws-detail-value">{workshopData.time}</div>
                  </div>
                </div>
                <div className="ws-detail-item-elegant">
                  <div className="ws-detail-icon">📍</div>
                  <div>
                    <div className="ws-detail-label">LOKASYON</div>
                    <div className="ws-detail-value">{workshopData.location}</div>
                  </div>
                </div>
                <div className="ws-detail-item-elegant">
                  <div className="ws-detail-icon">⏱️</div>
                  <div>
                    <div className="ws-detail-label">SÜRE</div>
                    <div className="ws-detail-value">{workshopData.duration}</div>
                  </div>
                </div>
              </div>

              <div className="ws-pricing-elegant">
                <div className="ws-price-current-elegant">
                  <span className="ws-currency">₺</span>
                  <span className="ws-amount">{workshopData.price}</span>
                  <span className="ws-period"></span>
                </div>
                {workshopData.originalPrice && (
                  <div className="ws-price-original-elegant">
                    <del>{workshopData.originalPrice} TL</del>
                  </div>
                )}
              </div>

              <div className="ws-action-buttons-elegant">
                <button 
                  className="ws-btn-details-elegant"
                  onClick={() => setSelectedWorkshop(workshopData)}
                >
                  DETAYLARI GÖR
                </button>
                <button 
                  className="ws-btn-reserve-elegant"
                  onClick={() => setShowBookingModal(true)}
                >
                  REZERVASYON YAP
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Detail Modal - Elegant */}
      {selectedWorkshop && (
        <div className="ws-modal-overlay-elegant" onClick={() => setSelectedWorkshop(null)}>
          <div className="ws-modal-elegant" onClick={(e) => e.stopPropagation()}>
            <div className="ws-modal-header-elegant">
              <button className="ws-modal-close-elegant" onClick={() => setSelectedWorkshop(null)}>
                <span>✕</span>
              </button>
              <h2 className="ws-modal-title">{selectedWorkshop.title}</h2>
              <p className="ws-modal-subtitle">{selectedWorkshop.subtitle}</p>
            </div>

            <div className="ws-modal-content-elegant">
              <div className="ws-modal-description">
                <p>{selectedWorkshop.description}</p>
              </div>

              <div className="ws-modal-info-grid">
                <div className="ws-info-item">
                  <div className="ws-info-label">TARİH</div>
                  <div className="ws-info-value">{selectedWorkshop.date}</div>
                </div>
                <div className="ws-info-item">
                  <div className="ws-info-label">SAAT</div>
                  <div className="ws-info-value">{selectedWorkshop.time}</div>
                </div>
                <div className="ws-info-item">
                  <div className="ws-info-label">LOKASYON</div>
                  <div className="ws-info-value">{selectedWorkshop.location}</div>
                </div>
                <div className="ws-info-item">
                  <div className="ws-info-label">SÜRE</div>
                  <div className="ws-info-value">{selectedWorkshop.duration}</div>
                </div>
              </div>

              <div className="ws-modal-price-display">
                <div className="ws-modal-current-price">{selectedWorkshop.price} TL</div>
                {selectedWorkshop.originalPrice && (
                  <div className="ws-modal-original-price">{selectedWorkshop.originalPrice} TL</div>
                )}
              </div>

              <button 
                className="ws-modal-reserve-btn"
                onClick={() => {
                  setShowBookingModal(true);
                  setSelectedWorkshop(null);
                }}
              >
                REZERVASYON YAP
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Booking Modal - Elegant */}
      {showBookingModal && (
        <div className="ws-modal-overlay-elegant" onClick={() => setShowBookingModal(false)}>
          <div className="ws-booking-modal-elegant" onClick={(e) => e.stopPropagation()}>
            <div className="ws-booking-header">
              <button className="ws-modal-close-elegant" onClick={() => setShowBookingModal(false)}>
                <span>✕</span>
              </button>
              <h2 className="ws-booking-title">REZERVASYON</h2>
              <p className="ws-booking-subtitle">21 OCAK 2026 • 18:00-21:00</p>
            </div>

            <div className="ws-booking-content-elegant">
              <form onSubmit={handleBookingSubmit} className="ws-booking-form-elegant">
                <div className="ws-form-row">
                  <div className="ws-form-group-elegant">
                    <label>Ad Soyad</label>
                    <input
                      type="text"
                      name="name"
                      value={bookingData.name}
                      onChange={handleInputChange}
                      placeholder=""
                      required
                      className="ws-form-input-elegant"
                    />
                  </div>
                </div>

                <div className="ws-form-row">
                  <div className="ws-form-group-elegant">
                    <label>E-posta</label>
                    <input
                      type="email"
                      name="email"
                      value={bookingData.email}
                      onChange={handleInputChange}
                      placeholder=""
                      required
                      className="ws-form-input-elegant"
                    />
                  </div>
                </div>

                <div className="ws-form-row">
                  <div className="ws-form-group-elegant">
                    <label>Telefon</label>
                    <input
                      type="tel"
                      name="phone"
                      value={bookingData.phone}
                      onChange={handleInputChange}
                      placeholder=""
                      required
                      className="ws-form-input-elegant"
                    />
                  </div>
                </div>

                <div className="ws-form-row">
                  <div className="ws-form-group-elegant">
                    <label>Katılımcı Sayısı</label>
                    <select
                      name="participants"
                      value={bookingData.participants}
                      onChange={handleInputChange}
                      className="ws-form-select-elegant"
                    >
                      <option value="1">1 Kişi</option>
                      <option value="2">2 Kişi</option>
                      <option value="3">3 Kişi</option>
                      <option value="4">4 Kişi</option>
                    </select>
                  </div>
                </div>

                <div className="ws-price-summary-elegant">
                  <div className="ws-summary-item">
                    <span>Atölye Ücreti</span>
                    <span>{workshopData.price} TL</span>
                  </div>
                  <div className="ws-summary-item">
                    <span>Katılımcı Sayısı</span>
                    <span>{bookingData.participants}</span>
                  </div>
                  <div className="ws-summary-total">
                    <span>TOPLAM</span>
                    <span>{workshopData.price * parseInt(bookingData.participants)} TL</span>
                  </div>
                </div>

                <button type="submit" className="ws-submit-btn-elegant">
                  WHATSAPP İLE REZERVASYON
                </button>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Workshops;